// src/api/reporterService.js

import axios from 'axios';
import { API_REPORTER_ENDPOINT } from '../authApi/reporterApi'; // Adjust path if needed

// Helper to get the current token from localStorage
const getToken = () => localStorage.getItem('token');

// Helper to create authorized headers for JSON data
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
    'Content-Type': 'application/json',
  },
});

// Helper to create authorized headers for FormData (e.g., file uploads)
const getAuthHeadersForFormData = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});


export const getDashboardStats = async () => {
  try {
    const response = await axios.get(API_REPORTER_ENDPOINT.GET_DASHBOARD_STATS, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard stats:', error.response?.data || error.message);
    throw error;
  }
};

export const createNews = async (formData) => {
  try {
    const response = await axios.post(API_REPORTER_ENDPOINT.CREATE_NEWS, formData, getAuthHeadersForFormData());
    return response.data;
  } catch (error) {
    console.error("Error creating news:", error.response?.data || error.message);
    throw error;
  }
};

export const updateNews = async (newsId, updateData, hasMedia = false) => {
  try {
    const headers = hasMedia ? getAuthHeadersForFormData() : getAuthHeaders(); // Call getAuthHeaders() / getAuthHeadersForFormData()
    const response = await axios.put(API_REPORTER_ENDPOINT.UPDATE_NEWS(newsId), updateData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error in updateNews (ID: ${newsId}):`, error.response?.data || error.message);
    throw error;
  }
};
 export const uploadMediaFiles = async (formData) => {
  try {
    const response = await axios.post(
     API_REPORTER_ENDPOINT.UPLOAD_MEDIA, // endpoint constant
      formData, // FormData object with files
      {
        headers: {
          ...getAuthHeaders().headers, // auth headers if needed
          "Content-Type": "multipart/form-data", // file upload ke liye zaroori
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in uploadMedia:", error.response?.data || error.message);
    throw error;
  }
};




// --- PUBLIC LOOKUP DATA (Categories, Subcategories) ---
// These are public endpoints, accessible without specific role,
// but authentication is still required as per your routes for reporters.
export const getAllCategories = async () => {
  try {
    const response = await axios.get(API_REPORTER_ENDPOINT.GET_ALL_CATEGORIES, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error.response?.data || error.message);
    throw error;
  }
};

export const getAllSubCategories = async (params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    const url = `${API_REPORTER_ENDPOINT.GET_ALL_SUBCATEGORIES}${queryString ? `?${queryString}` : ''}`;
    const response = await axios.get(url, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error fetching subcategories:", error.response?.data || error.message);
    throw error;
  }
};

// --- GET REPORTER'S OWN NEWS ---
// export const getMyNews = async (params = {}) => {
//   try {

//     const url = `${API_REPORTER_ENDPOINT.GET_MY_NEWS}`;
//     const response = await axios.get(url, getAuthHeaders());
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching reporter's news:", error.response?.data || error.message);
//     throw error;
//   }
// };

export const getMyNews = async (params = {}) => {
  try {
    // Build query string from params
    const queryString = new URLSearchParams(params).toString();
    const url = `${API_REPORTER_ENDPOINT.GET_MY_NEWS}?${queryString}`;

    const response = await axios.get(url, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error fetching reporter's news:", error.response?.data || error.message);
    throw error;
  }
};


// ✅ Delete news
export const deleteNews = async (id) => {
  try {
    const url = `${API_REPORTER_ENDPOINT.DELETE_NEWS}/${id}`;
    const response = await axios.delete(url, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error deleting news:", error.response?.data || error.message);
    throw error;
  }
};

// export const createShort = async (formData) => {
//   try {
//     const response = await axios.post(
//       API_REPORTER_ENDPOINT.CREATE_SHORT,   // Example: "/api/v1/shorts"
//       formData,
//       {
//         headers: {
//           ...getAuthHeaders(),       // JWT / Authorization headers
//           "Content-Type": "multipart/form-data",
//         },
//       }
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error creating short:", error.response?.data || error.message);
//     throw error.response?.data || { message: "Failed to create short" };
//   }
// };

// export const createShort = async (formData) => {
//   try {
//     const response = await axios.post(
//       API_REPORTER_ENDPOINT.CREATE_SHORT,
//       formData,
//       {
//         headers: {
//           ...getAuthHeaders(),
//           "Content-Type": "multipart/form-data",
//         },
//       }
//     );
//     return response.data; // already unwrapped
//   } catch (error) {
//     console.error("Error creating short:", error.response?.data || error.message);
//     throw error.response?.data || { message: "Failed to create short" };
//   }
// };

export const createShort = async (formData) => {
  try {
    const response = await axios.post(
      API_REPORTER_ENDPOINT.CREATE_SHORT,
      formData,
      getAuthHeadersForFormData()   // ✅ sirf Authorization bhejega
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create short:", error.response?.data || error.message);
    throw error?.response?.data || { message: "Error creating short" };
  }
};

export const getMyShorts = async (params = {}) => {
  try {
    // Convert params to query string
    const queryString = new URLSearchParams(params).toString();
    const url = `${API_REPORTER_ENDPOINT.GET_MY_SHORTS}?${queryString}`;

    const response = await axios.get(url, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching reporter's shorts:",
      error.response?.data || error.message
    );
    throw error;
  }
};


export const deleteShort = async (id) => {
  try {
    const response = await axios.delete(
      `${API_REPORTER_ENDPOINT.DELETE_SHORT}/${id}`,
      getAuthHeaders() // ✅ Delete ke liye normal headers
    );
    return response.data;
  } catch (error) {
    console.error("Failed to delete short:", error.response?.data || error.message);
    throw error?.response?.data || { message: "Error deleting short" };
  }
};

export const updateShort = async (id, formData) => {
  try {
    const response = await axios.put(
      `${API_REPORTER_ENDPOINT.UPDATE_SHORT}/${id}`,
      formData,
      getAuthHeadersForFormData()
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update short:", error.response?.data || error.message);
    throw error?.response?.data || { message: "Error updating short" };
  }
};

// Get all videos
export const getAllVideos = async () => {
  try {
    const response = await axios.get(API_REPORTER_ENDPOINT.GET_ALL_VIDEOS, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in getAllVideos:", error.response?.data || error.message);
    throw error;
  }
};

// Create a video
export const createVideo = async (formData) => {
  try {
    const response = await axios.post(API_REPORTER_ENDPOINT.CREATE_VIDEO, formData, getAuthHeadersForFormData());
    return response.data;
  } catch (error) {
    console.error("Error in createVideo:", error.response?.data || error.message);
    throw error;
  }
};

// Update a video
export const updateVideo = async (videoId, formData) => {
  try {
    const response = await axios.put(`${API_REPORTER_ENDPOINT.UPDATE_VIDEO}/${videoId}`, formData, getAuthHeadersForFormData());
    return response.data;
  } catch (error) {
    console.error("Error in updateVideo:", error.response?.data || error.message);
    throw error;
  }
};

// Delete a video
export const deleteVideo = async (videoId) => {
  try {
    const response = await axios.delete(`${API_REPORTER_ENDPOINT.DELETE_VIDEO}/${videoId}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in deleteVideo:", error.response?.data || error.message);
    throw error;
  }
};


// ✅ Reporter: Create Story (agar canDirectPost false hai to admin approval me jayegi)
export const createStoryByReporter = async (formData) => {
  try {
    const response = await axios.post(
      API_REPORTER_ENDPOINT.CREATE_STORY,
      formData,
      getAuthHeadersForFormData()
    );
    return response.data;
  } catch (error) {
    console.error("Error creating story (reporter):", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Reporter: Get My Own Stories (draft/pending/posted/rejected sab)
export const getMyStories = async () => {
  try {
    const response = await axios.get(API_REPORTER_ENDPOINT.MY_STORIES, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error fetching my stories:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Reporter: Get Single Story By ID
export const getStoryByIdReporter = async (storyId) => {
  try {
    const response = await axios.get(
      `${API_REPORTER_ENDPOINT.GET_STORY_BY_ID}/${storyId}`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching story by ID:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Reporter: Add More Slides to Own Story
export const addSlidesToStoryReporter = async (storyId, formData) => {
  try {
    const response = await axios.post(
      `${API_REPORTER_ENDPOINT.ADD_SLIDES}/${storyId}`,
      formData,
      getAuthHeadersForFormData()
    );
    return response.data;
  } catch (error) {
    console.error("Error adding slides:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Reporter: Update Own Story (title/summary/category/tags)
// Note: agar reporter ke paas canDirectPost nahi hai, edit karne par status backend khud
// wapas "pending_approval" kar dega — dobara admin approval chahiye hogi.
export const updateStoryByReporter = async (storyId, payload) => {
  try {
    const response = await axios.put(
      `${API_REPORTER_ENDPOINT.UPDATE_STORY}/${storyId}`,
      payload,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error updating story:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Reporter: Delete Own Story
export const deleteStory = async (storyId) => {
  try {
    const response = await axios.delete(
      `${API_REPORTER_ENDPOINT.DELETE_STORY}/${storyId}`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting story:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Get Story By ID
export const getStoryById = async (storyId) => {
  try {
    const response = await axios.get(`${API_REPORTER_ENDPOINT.GET_STORY_BY_ID}/${storyId}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error fetching story by ID:", error.response?.data || error.message);
    throw error;
  }
};
